import RxEventEmitter from './RxEventEmitter';

const waitFormSaveResponse = (panelId: string): Promise<boolean> =>
	new Promise((resolve, reject) => {
		RxEventEmitter.listen('external_' + panelId, {
			next: (data: any) => {
				if (data.windowId == panelId) {
					if (data.type == 'FORM_SAVED') {
						RxEventEmitter.subjects['external_' + panelId]?.unsubscribe();
						resolve(true);
					} else if (data.type == 'FORM_SAVED_FAILED') {
						resolve(false);
					}
				}
			}
		});
		setTimeout(() => {
			reject(new Error(`${panelId} Form Save Response timeout!`));
			RxEventEmitter.subjects['external_' + panelId]?.unsubscribe();
		}, 60 * 1000);
	});

export { waitFormSaveResponse };
